import { Component, ViewEncapsulation } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { LanguageDTO } from '@signature-it/ngx-generic/models';
import { LanguageService } from '@signature-it/ngx-generic/services';
import { ILanguage } from '@signature-it/ngx-generic/interfaces';

@Component({
    selector: 'dropdown-langs',
    templateUrl: './dropdown-langs.html',
    styleUrls: ['./dropdown-langs.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class DropdownLangsComponentGeneric {
    langList: ILanguage[] = [];
    private destroy$ = new Subject<void>();

    constructor(public langSvc: LanguageService) {
    }

	ngOnInit() {
        this.langSvc.langList$.pipe(takeUntil(this.destroy$)).subscribe(languages => {
            if (languages && languages.length) {
                this.langList = languages;
                this.destroy$.next();
                this.destroy$.complete();
            }
        });
	}

    isCurrentLang(lang: LanguageDTO): boolean {
        return this.langSvc.CurrLangName && this.langSvc.CurrLang.id === lang.id;
    }

}
